export const firebaseObjectToArray = (obj) => {
    return obj
        ? Object.keys(obj).map((id) => {
              return {
                  id,
                  ...obj[id]
              }
          })
        : []
}

export const arrayToFirebaseWithTrueValues = (arr) =>
    arr
        ? arr.reduce((acc, item) => {
              acc[item] = true
              return acc
          }, {})
        : null

export const firebaseObjectWithId = (obj) => obj || false

export const clearFields = (obj) =>
    Object.keys(obj).reduce((acc, key) => {
        if (Array.isArray(obj[key])) {
            acc[key] = []
        } else if (typeof obj[key] === 'boolean') {
            acc[key] = false
        } else {
            acc[key] = ''
        }
        return acc
    }, {})

export const parseSearchValues = (formValues) => {
    let searchParams = {}
    Object.keys(formValues).map((key) => {
        if (formValues[key]) {
            searchParams.key = key
            searchParams.value = formValues[key]
        }
    })
    return searchParams
}

export const toFixed = (value, n = 2) => {
    const v = value.split('.')
    if (n <= 0) return v[0]
    let f = v[1] || ''
    if (f.length > n) return `${v[0]}.${f.substr(0, n)}`
    while (f.length < n) f += '0'
    return `${v[0]}.${f}`
}
